import React from 'react';
import { DesignSystem } from '@everfi/design-system';
import { i18n } from '../i18n/translate.js';
import IconButton from '../core/components/IconButton/component.js';

/**
 * Renders a back button.
 * If action === true, it uses router to go back.
 * Else it calls the action function.
 */
var BackButton = function BackButton(_ref) {
  var action = _ref.action,
    router = _ref.router;
  var onClick = function onClick(e) {
    e.preventDefault();
    if (action === true) {
      if (router !== null && router !== void 0 && router.goBack) {
        router.goBack();
      } else {
        throw new Error('must pass router as a prop in order to use default back action');
      }
    } else if (typeof action === 'function') {
      action(e);
    }
  };
  return /*#__PURE__*/React.createElement(IconButton, {
    ariaLabel: i18n.t('Back'),
    variant: 'link',
    onClick: onClick,
    "data-back-arrow": true,
    colorScheme: 'brand',
    size: DesignSystem.Sizes.LG,
    tooltip: {
      content: i18n.t('Back')
    },
    icon: {
      iconName: 'fa-arrow-left'
    }
  });
};
BackButton.displayName = "BackButton";
export { BackButton };